import api from './api';

const uploadService = {
  /**
   * Faz upload de um ficheiro para o MinIO via backend.
   * @param {File} file - O ficheiro a enviar
   * @returns {Promise<string>} - A URL pública do ficheiro
   */
  async uploadImage(file) {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post('/upload/image', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    return response.data.url;
  },

  /**
   * Faz upload de um PDF para o backend.
   * @param {File} file - O ficheiro PDF a enviar
   * @returns {Promise<string>} - A URL pública do ficheiro
   */
  async uploadPdf(file) {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post('/upload/pdf', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    return response.data.url;
  },
};

export default uploadService;
